import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import Chart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';

const ViolationsByPolicyChart = ({ stats }) => {
  const theme = useTheme();

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Violations by Policy Type
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Number of violations detected per policy category
        </Typography>
        <Box height={300}>
          <Chart
            options={{
              chart: {
                type: 'bar',
              },
              xaxis: {
                categories:
                  stats?.violationStats?.map(item => item.policy) || [],
              },
              colors:
                stats?.violationStats?.map((item, index) => {
                  const colorMap = [
                    theme.palette.primary?.main || '#2196f3',
                    theme.palette.secondary?.main || '#9c27b0',
                  ];
                  return colorMap[index % colorMap.length];
                }) || [],
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '55%',
                },
              },
              dataLabels: {
                enabled: false,
              },
              legend: {
                position: 'top',
              },
            }}
            series={[
              {
                name: 'Violations',
                data: stats?.violationStats?.map(item => item.violations) || [],
              },
            ]}
            type="bar"
            height={300}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ViolationsByPolicyChart;
